<template>
	<div class="step">
		<SubHeader/>
		<div class="container">
			<div class="row">
				<form action="#" method="post" @submit.prevent="submit" class="col-md-7 mx-auto py-5">
					<!-- Form Fields -->
<!--					<div class="form-field">-->
<!--						<label for="firstName" class="form-label">First Name</label>-->
<!--						<input type="text" class="form-control" name="firstName" id="firstName" v-model="firstName" placeholder="Enter your first name" required>-->
<!--					</div>-->
<!--					<div class="form-field mt-3 pt-3">-->
<!--						<label for="lastName" class="form-label">Last Name</label>-->
<!--						<input type="text" class="form-control" name="lastName" id="lastName" v-model="lastName" placeholder="Enter your last name" required>-->
<!--					</div>-->
<!--					<div class="form-field mt-3 pt-3">-->
<!--						<label for="phone" class="form-label">Phone</label>-->
<!--						<input type="text" class="form-control" name="phone" id="phone" v-model="phone" placeholder="201-555-0123" required>-->
<!--					</div>-->

					<h4 class="mb-md-3">Your Account Details</h4>
					<div class="form-field mt-3 pt-3">
						<label for="password" class="form-label">Password</label>
						<div class="password-field">
							<input :type="(showPassword ? 'text' : 'password')" class="form-control" name="password" id="password" v-model="password" placeholder="Choose a strong password" required>
							<button type="button" @click="showPassword = !showPassword" tabindex="-1">
								<img src="../../assets/icons/eye.png" alt="Eye">
							</button>
						</div>
						<div class="password-errors mt-3" v-if="showErrors">
							<p class="text-danger fw-bolder small m-0" v-if="password && password.length < 8">Password should be at least 8 characters</p>
							<p class="text-danger fw-bolder small m-0" v-if="!matchRegex(password, /[A-Z]/)">Add at least one uppercase character (A-Z)</p>
							<p class="text-danger fw-bolder small m-0" v-if="!matchRegex(password, /[a-z]/)">Add at least one lowercase character (a-z)</p>
							<p class="text-danger fw-bolder small m-0" v-if="!matchRegex(password, /[0-9]/)">Add at least one numeric character (0-9)</p>
						</div>
						<p class="small col-md-8 fst-italic text-muted mt-3">Password should be at least 8 characters, contain an uppercase character, a lowercase character, a number and a symbol.</p>
					</div>

					<div class="form-field">
						<label for="state" class="form-label">State</label>
						<select class="form-control" name="state" id="state" required v-model="state">
							<option disabled selected value="">Select state</option>
							<option value="AL">Alabama</option>
							<option value="AK">Alaska</option>
							<option value="AZ">Arizona</option>
							<option value="AR">Arkansas</option>
							<option value="CA">California</option>
							<option value="CO">Colorado</option>
							<option value="CT">Connecticut</option>
							<option value="DE">Delaware</option>
							<option value="DC">District Of Columbia</option>
							<option value="FL">Florida</option>
							<option value="GA">Georgia</option>
							<option value="HI">Hawaii</option>
							<option value="ID">Idaho</option>
							<option value="IL">Illinois</option>
							<option value="IN">Indiana</option>
							<option value="IA">Iowa</option>
							<option value="KS">Kansas</option>
							<option value="KY">Kentucky</option>
							<option value="LA">Louisiana</option>
							<option value="ME">Maine</option>
							<option value="MD">Maryland</option>
							<option value="MA">Massachusetts</option>
							<option value="MI">Michigan</option>
							<option value="MN">Minnesota</option>
							<option value="MS">Mississippi</option>
							<option value="MO">Missouri</option>
							<option value="MT">Montana</option>
							<option value="NE">Nebraska</option>
							<option value="NV">Nevada</option>
							<option value="NH">New Hampshire</option>
							<option value="NJ">New Jersey</option>
							<option value="NM">New Mexico</option>
							<option value="NY">New York</option>
							<option value="NC">North Carolina</option>
							<option value="ND">North Dakota</option>
							<option value="OH">Ohio</option>
							<option value="OK">Oklahoma</option>
							<option value="OR">Oregon</option>
							<option value="PA">Pennsylvania</option>
							<option value="RI">Rhode Island</option>
							<option value="SC">South Carolina</option>
							<option value="SD">South Dakota</option>
							<option value="TN">Tennessee</option>
							<option value="TX">Texas</option>
							<option value="UT">Utah</option>
							<option value="VT">Vermont</option>
							<option value="VA">Virginia</option>
							<option value="WA">Washington</option>
							<option value="WV">West Virginia</option>
							<option value="WI">Wisconsin</option>
							<option value="WY">Wyoming</option>
						</select>
					</div>

					<p class="small mt-3">By continuing, you certify that you do not reside in Texas, Florida, Washington, or New Jersey. You understand and agree that if you are a resident of Texas, Florida, Washington, or New Jersey <!--(1)--> your investment shall be void and rejected <!--and (2) you will be responsible for all costs, fees and penalties in connection with a false certification as to your state of residence-->.</p>

					<div v-if="!isValidState" class="mt-3">
						<p class="text-danger fw-bolder m-0 small">We cannot accept investments from residents of Texas, Florida, Washington, and New Jersey at this time; however we expect to be able to accept investments in these states soon.</p>
						<p class="text-danger fw-bolder mt-2 small">You may provide your contact info so that we may notify you when investments in these states are possible.</p>
						<a href="https://www.reiturn.com/reserve-your-investment" target="_blank" class="btn btn-primary mt-3 mb-3 mb-md-0">Get Notification</a>
					</div>

					<div class="password-errors mt-3" v-if="error">
						<p class="text-danger fw-bolder small m-0" v-if="error === 'missing_data'">Please enter email and password.</p>
						<p class="text-danger fw-bolder small m-0" v-if="error === 'account_auth_failed'">You already have an account. Please enter your correct email and password.<br>If you have forgotten your password, you can <a :href="resetPasswordLink" class="text-brand">reset your password</a>.</p>
					</div>

					<!-- Form Navigation -->
					<div class="d-flex flex-column-reverse flex-md-row justify-content-md-end pt-2">
						<button class="btn btn-primary btn-wide" type="submit" :disabled="loading" v-if="isValidState">
							<span v-if="!loading">Continue</span>
							<span class="spinner-border" v-if="loading"></span>
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import SubHeader from "@/components/SubHeader";
import repository from "@/repository/repository";
import Logs from "@/repository/logs";
import {PORTAL_URL} from "@/main";

export default {
    name: "PersonalForm",
    components: {SubHeader},
	beforeMount() {
        // Verify the previous step is finished
        if(!this.$store.getters.auth.finished) {
            this.$router.replace("/");
		}

        // Verify if the current step is finished
        if(this.$store.getters.personal.finished) {
            this.$router.replace("/details");
        }
    },
    data() {
        return {
            firstName: this.$store.getters.personal.firstName,
            lastName: this.$store.getters.personal.lastName,
            email: this.$store.getters.auth.email,
            phone: this.$store.getters.personal.phone,
            password: null,
            state: this.$store.getters.contact.state,
            showPassword: false,
            error: null,
            showErrors: false,
            loading: false,
		}
	},
	methods: {
        back() {
            this.$router.back();
		},
        submit() {
            // Verify Password
            if(!this.checkPassword()) {
                this.showErrors = true;
                return false;
            }

            // Start Loading Effect
            this.loading = true;
            this.error = false;

            // Submit Request & Proceed
			let payload = {
                email: this.email,
                firstName: this.firstName,
                lastName: this.lastName,
                phone: this.phone,
                password: this.password,
                state: this.state,
            };
            repository.post('/auth', payload)
                .then(response => {

                    // This is new account, store the token and continue
                    if(response.data.code === 'account_created') {
                        this.$store.commit("updateAuth", {
                            token: response.data.token,
                            email: this.email,
                            password: this.password,
                            firstName: this.firstName,
                            lastName: this.lastName,
                            phone: this.phone,
                            state: this.state,
                        });
                    }

                    // This is old account, we may already have some data
                    if(response.data.code === 'account_found') {
                        this.$store.commit("updateAuth", {
                            token: response.data.token,
                            email: this.email,
                            password: this.password,
                            firstName: this.firstName,
                            lastName: this.lastName,
                            phone: this.phone,
                            state: this.state,
                        });
                        this.$store.commit("updateAll", response.data.user);
                    }

                    this.loading = false;
                    this.$router.push("/details");
                })
                .catch(error => {
                    console.log(error);
                    this.error = error.response.data.code;
                    this.loading = false;
                    Logs.save('onboarding.personalForm', error.response, payload);
                })
		},
        matchRegex(input, regex) {
            return regex.test(input);
        },
        checkPassword() {
            if(!this.password) return false;
            if(this.password.length < 8) return false;
            if(!this.matchRegex(this.password, /[A-Z]/)) return false;
            if(!this.matchRegex(this.password, /[a-z]/)) return false;
            return this.matchRegex(this.password, /[0-9]/);
        },
	},
    computed: {
        isValidState() {
            if(!this.state) return true;
            return ["TX", "FL", "WA", "NJ"].indexOf(this.state) < 0;
        },
		resetPasswordLink() {
			return PORTAL_URL + "/forgot-password";
		},
    },
}
</script>

<style lang="scss">
.password-field {
	position: relative;

	button {
		position: absolute;
		bottom: 0;
		right: 0;
		top: 0;
		margin: auto;
		background: none;
		border: none;
		box-shadow: none;
		outline: none;
		width: 3rem;
		height: 3rem;
		padding: 0.25rem;
		opacity: 0.25;
		transition: 0.2s ease all;

		&:hover {
			opacity: 1;
		}

		img {
			width: 1.5rem;
		}
	}
}

.text-brand {
	color: #16193A;
	font-weight: bold;
}
</style>